import React from 'react';
import styled from 'styled-components';

const PrizesModal = ({ isOpen, onClose, campaign }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>Premios</ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        
        <PrizesList>
          {campaign.prizes.map((prize, index) => (
            <PrizeItem key={index}>
              <PrizeIcon>
                {prize.type === 'direct' ? '🎁' : 
                 prize.type === 'coupon' ? '🎫' : '🏆'}
              </PrizeIcon>
              <PrizeInfo>
                <PrizeName>{prize.name}</PrizeName>
                <PrizeQuantity>
                  Disponibles: <span>{prize.quantity}</span>
                </PrizeQuantity>
              </PrizeInfo>
            </PrizeItem>
          ))}
        </PrizesList>
      </ModalContent>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(76, 29, 149, 0.9);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
  padding: 1rem;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 215, 0, 0.05);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 215, 0, 0.2);
    border-radius: 4px;
    
    &:hover {
      background: rgba(255, 215, 0, 0.3);
    }
  }
`;

const ModalContent = styled.div`
  background: linear-gradient(135deg, 
    rgba(88, 28, 135, 0.97) 0%,
    rgba(67, 20, 102, 0.97) 100%
  );
  border-radius: 24px;
  padding: 2rem;
  max-width: 500px;
  width: 100%;
  border: 1px solid rgba(255, 215, 0, 0.2);
  box-shadow: 0 8px 32px rgba(76, 29, 149, 0.5);
  margin: 2rem auto;
  max-height: calc(100vh - 4rem);
  overflow-y: auto;
  position: relative;
  padding-top: 0;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 215, 0, 0.05);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 215, 0, 0.2);
    border-radius: 3px;
    
    &:hover {
      background: rgba(255, 215, 0, 0.3);
    }
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 -2rem 2rem -2rem;
  position: sticky;
  top: 0;
  background: inherit;
  padding: 1.5rem 2rem;
  z-index: 1;
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(255, 215, 0, 0.1);
  background: linear-gradient(135deg, 
    rgba(88, 28, 135, 0.97) 0%,
    rgba(67, 20, 102, 0.97) 100%
  );
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
`;

const ModalTitle = styled.h2`
  font-family: 'BaksoSapi', sans-serif;
  color: #ffd700;
  font-size: 1.5rem;
  margin: 0;
  letter-spacing: 1px;
  background: linear-gradient(to right, #ffd700, #ffb347);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 215, 0, 0.8);
  font-size: 2rem;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: all 0.3s ease;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  &:hover {
    color: #ffd700;
    transform: rotate(90deg);
    background: rgba(255, 215, 0, 0.1);
  }
`;

const PrizesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const PrizeItem = styled.div`
  background: rgba(109, 40, 217, 0.2);
  border: 1px solid rgba(255, 215, 0, 0.1);
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(124, 58, 237, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(76, 29, 149, 0.4);
  }
`;

const PrizeIcon = styled.div`
  font-size: 1.5rem;
  min-width: 40px;
  text-align: center;
`;

const PrizeInfo = styled.div`
  flex-grow: 1;
`;

const PrizeName = styled.div`
  color: #ffd700;
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 0.2rem;
`;

const PrizeQuantity = styled.div`
  color: rgba(255, 215, 0, 0.7);
  font-size: 0.9rem;
  
  span {
    color: #ffd700;
    font-weight: 600;
  }
`;

export default PrizesModal; 